/* eslint-disable */
export default function (Vue) {
  Vue.auth = {
    setToken (token, expiration, userName) {
      localStorage.setItem('token', token);
      localStorage.setItem('expiration', expiration);
      localStorage.setItem('userName', userName);
    },
    getToken () {
      let token = localStorage.getItem('token');
      let userName = localStorage.getItem('userName');
      let pw = 'nopw';
      let expiration = localStorage.getItem('expiration');

      if (!token || !expiration) return false;
      if (Date.now() > parseInt(expiration)) {
        this.destroyToken();
        return null;
      } else return [userName, pw];
    },
    destroyToken () {
      localStorage.removeItem('token');
      localStorage.removeItem('expiration');
      localStorage.removeItem('pw');
      localStorage.removeItem('userName');
    },
    isAuthenticated () {
      return this.getToken();
    }
  };
  Object.defineProperties(Vue.prototype, {
    $auth: {
      get () {
        return Vue.auth
      }
    }
  })
}
